import axios from 'axios';
import appconst from './appconst';
import Vue from 'vue';
import { swal } from 'vue/types/umd';
import { router } from '@/router';
import util from "../lib/util";
const ajax = axios.create({
  baseURL: appconst.remoteServiceBaseUrl,
  timeout: 120000,
});
ajax.interceptors.request.use(
  function(config) {
    if (!!window.abp.auth.getToken()) {

      config.headers.common['Authorization'] =
        'Bearer ' + window.abp.auth.getToken();
    }
    config.headers.common[
      '.AspNetCore.Culture'
    ] = window.abp.utils.getCookieValue('Abp.Localization.CultureName');
    config.headers.common[
      'Abp.TenantId'
    ] = window.abp.multiTenancy.getTenantIdCookie();
    return config;
  },
  function(error) {
 
    return Promise.reject(error);
  }
);
let vm = new Vue({});
ajax.interceptors.response.use(
  
  (respon) => {
    return respon;
  },
  (error) => {
    console.log(error.response);
    if(error.response.status==401){

      util.abp.auth.clearToken();
      location.reload();
    }
    if (
      !!error.response &&
      !!error.response.data.error &&
      !!error.response.data.error.message &&
      error.response.data.error.details
    ) {

      //  vm.$Modal.error({title:error.response.data.error.message,content:error.response.data.error.details})
      vm.$swal({
        icon: 'error',
        title: error.response.data.error.message,
        text: error.response.data.error.details,
        confirmButtonText: 'Tamam',
        showConfirmButton: false,
      })
    } else if (
      !!error.response &&
      !!error.response.data.error &&
      !!error.response.data.error.message
    ) {
      //  vm.$Modal.error({title:window.abp.localization.localize("LoginFailed"),content:error.response.data.error.message})
   
      vm.$swal({
        icon: 'error',
        title: error.response.data.error.message,
        text: error.response.data.error.details,
        confirmButtonText: 'Tamam',
        showConfirmButton: false,
      });
    } else if (!error.response) {
      //  vm.$Modal.error(window.abp.localization.localize('UnknownError'));
      vm.$swal({
        icon: 'error',
        title: 'Hata',
        text: window.abp.localization.localize('UnknownError'),
        confirmButtonText: 'Tamam',
        showConfirmButton: false,
      });
    }
    setTimeout(() => {
      // vm.$Message.destroy();
    }, 1000);
    return Promise.reject(error);
  }
);
export default ajax;
